

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index'], function ($, angular, squid, template) {

    return angular.module('xo-generic-message.directive', ['squid', 'xomodel.checkout']).directive('xoGenericMessage', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '='
            },

            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate) {

                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    event.preventDefault();
                });

                $('.paypalHeaderWrapper').hide();
                $('.footerWrapper').addClass('genericMessage');

                var titleKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
                    DEFAULT: 'paymentSuccessTitle'
                };

                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;

                var contentKeyMapping = {
                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
                    DEFAULT: 'paymentSuccessMessage'
                };
                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];

                if (contentKey) {
                    $scope.contentKey = 'genericMessage.' + contentKey;
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                }).then(function () {
                    var merchant = $scope.checkoutAppData.merchant;
                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                });

                $scope.$on('$destroy', function (event) {
                    $('.paypalHeaderWrapper').show();
                    $('.footerWrapper').removeClass('genericMessage');
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/generic-message/directive.js
 ** module id = 218
 ** module chunks = 1
 **/